import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

const CustomSelect = ({
  placeholder,
  options,
  value,
  setValue,
  label,
  disabled,
  removeArrow,
  defaultValue,
  allowClear = false,
}) => {
  const [inputProps, setInputProps] = useState({});
  const handleChange = (e) => {
    setValue(e.target.value);
  };
  useEffect(() => {
    if (removeArrow) setInputProps({ IconComponent: () => null });
  }, [removeArrow]);
  return (
    <FormControl sx={{ minWidth: "27.5rem", marginBottom: "1rem" }}>
      <Typography
        sx={{
          fontSize: "0.75rem",
          fontWeight: 500,
          lineHeight: "150%",
          marginBottom: "0.5rem",
        }}
      >
        {label}:
      </Typography>
      <Select
        onChange={handleChange}
        value={value || ""}
        defaultValue={defaultValue}
        disabled={disabled}
        renderValue={(val) => {
          if (!val) {
            return <em>{placeholder}</em>;
          }
          // Find the option to get its label for display
          const selectedOption = options.find(opt => opt.name === val || opt === val);
          if (selectedOption && selectedOption.label) {
            return selectedOption.label;
          }
          // Fallback for options that might be strings or don't have labels
          return typeof selectedOption === 'string' ? selectedOption : (selectedOption?.name || val);
        }}
        inputProps={inputProps}
        sx={{ borderRadius: "0.5rem", height: "2.8125rem" }}
      >
        {allowClear && (
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
        )}
        {options.map((option, index) => {
          // Handle both object format {name, label} and string format
          const optionName = typeof option === 'string' ? option : option.name;
          const optionLabel = typeof option === 'string' ? option : (option.label || option.name);
          const optionValue = typeof option === 'string' ? option : option.name;
          
          return (
            <MenuItem key={index + optionName} value={optionValue}>
              {optionLabel}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;
